import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description: string;
    keywords?: string;
    name?: string;
    type?: string;
    image?: string;
    url?: string;
    canonical?: string;
    jsonLd?: Record<string, any>;
    noIndex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    keywords,
    name = 'Ольга Гальперина',
    type = 'website',
    image,
    url = 'https://olgagalperina.com',
    canonical,
    jsonLd,
    noIndex = false,
}) => {
    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />
            {keywords && <meta name='keywords' content={keywords} />}
            {canonical && <link rel="canonical" href={`https://olgagalperina.com${canonical}`} />}
            {noIndex && <meta name="robots" content="noindex" />}

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}

            {/* Facebook tags */}
            <meta property='og:type' content={type} />
            <meta property='og:title' content={title} />
            <meta property='og:description' content={description} />
            {image && <meta property='og:image' content={image} />}
            <meta property='og:url' content={url} />

            {/* Twitter tags */}
            <meta name='twitter:creator' content={name} />
            <meta name='twitter:card' content={type} />
            <meta name='twitter:title' content={title} />
            <meta name='twitter:description' content={description} />
            {image && <meta name='twitter:image' content={image} />}
        </Helmet>
    );
}

export default SEO;
